/* ============================================
   Custom Kids Name Stamp — Configurator JS
   ============================================ */

(function () {
  'use strict';

  var MAX_CHARS_WITH_ICON = 18;
  var MAX_CHARS_NO_ICON   = 26;

  var state = {
    shape: null,   // 'QN32' or 'QN41'
    color: null,   // 'Blue' or 'Pink'
    withIcon: null, // true or false
    icon: null,    // icon id (e.g. "a01") or null
    iconUrl: null, // CDN url for selected icon
    name: ''
  };

  var tracking = {
    configStartTracked: false,
    previewReadyTracked: false
  };

  // --- DOM refs ---
  var form, nameInput, charCounter, previewStamp, previewContent, addBtn;
  var shapeError, colorError, iconToggleError, iconError, nameError;

  function init() {
    form          = document.getElementById('ns-form');
    nameInput     = document.getElementById('ns-name');
    charCounter   = document.getElementById('ns-char-counter');
    previewStamp  = document.getElementById('ns-preview-stamp');
    previewContent = document.getElementById('ns-preview-content');
    addBtn        = document.getElementById('ns-add-to-cart');

    shapeError      = document.getElementById('ns-error-shape');
    colorError      = document.getElementById('ns-error-color');
    iconToggleError = document.getElementById('ns-error-icon-toggle');
    iconError       = document.getElementById('ns-error-icon');
    nameError       = document.getElementById('ns-error-name');

    buildIconPicker();
    bindShapeOptions();
    bindColorOptions();
    bindIconToggle();
    bindIconPicker();
    bindNameInput();
    bindAddToCart();
    updatePreview();
  }

  function getLanguage() {
    var lang = document.documentElement.getAttribute('lang') || '';
    if (lang) return lang.toLowerCase();
    return (window.location.pathname.indexOf('/zh') === 0) ? 'zh-hk' : 'en';
  }

  function getBaseEventParams() {
    return {
      product_handle: 'custom-kids-name-stamp',
      page_path: window.location.pathname,
      page_language: getLanguage(),
      stamp_shape: state.shape || '',
      stamp_color: state.color || '',
      has_icon: state.withIcon === true ? 'yes' : (state.withIcon === false ? 'no' : ''),
      icon_id: state.icon || '',
      name_length: (state.name || '').trim().length
    };
  }

  function trackEvent(name, params) {
    var payload = params || {};
    if (typeof window.gtag === 'function') {
      window.gtag('event', name, payload);
    }
  }

  function markConfigStart(interactionType) {
    if (tracking.configStartTracked) return;
    tracking.configStartTracked = true;
    var params = getBaseEventParams();
    params.interaction_type = interactionType;
    trackEvent('stamp_config_start', params);
  }

  function isPreviewReady() {
    var trimmedName = (state.name || '').trim();
    if (!state.shape || !state.color || state.withIcon === null || !trimmedName) return false;
    if (trimmedName.length > getMaxChars()) return false;
    if (state.withIcon && !state.icon) return false;
    return true;
  }

  function maybeTrackPreviewReady() {
    if (tracking.previewReadyTracked || !isPreviewReady()) return;
    tracking.previewReadyTracked = true;
    trackEvent('stamp_preview_ready', getBaseEventParams());
  }

  function trackValidationErrors() {
    var missingFields = [];
    var trimmedName = (state.name || '').trim();

    if (!state.shape) missingFields.push('shape');
    if (!state.color) missingFields.push('color');
    if (state.withIcon === null) missingFields.push('icon_toggle');
    if (state.withIcon && !state.icon) missingFields.push('icon');
    if (!trimmedName) missingFields.push('name');
    if (trimmedName && trimmedName.length > getMaxChars()) missingFields.push('name_too_long');

    var params = getBaseEventParams();
    params.missing_fields = missingFields.join(',');
    trackEvent('stamp_config_error', params);
  }

  // --- Category tabs ---
  var ICON_CATEGORIES = [
    { key: 'all', label: 'All' },
    { key: 'boys', label: 'Boys' },
    { key: 'girls', label: 'Girls' },
    { key: 'plants', label: 'Plants' },
    { key: 'animals', label: 'Animals' }
  ];

  var activeCategory = 'all';

  function buildIconPicker() {
    var picker = document.getElementById('ns-icon-picker');
    var icons = window.stampIcons || [];

    // Build tabs
    var html = '<div class="ns-icon-tabs">';
    for (var t = 0; t < ICON_CATEGORIES.length; t++) {
      var cat = ICON_CATEGORIES[t];
      html += '<button type="button" class="ns-icon-tab' + (cat.key === 'all' ? ' active' : '') + '" data-category="' + cat.key + '">' + cat.label + '</button>';
    }
    html += '</div>';

    // Build grid
    html += '<div class="ns-icon-grid">';
    for (var i = 0; i < icons.length; i++) {
      var icon = icons[i];
      html += '<label class="ns-icon-option" data-value="' + icon.id + '" data-url="' + icon.url + '" data-category="' + (icon.category || '') + '">';
      html += '<input type="radio" name="stamp_icon" value="' + icon.id + '">';
      html += '<img src="' + icon.url + '" width="40" height="40" alt="' + icon.label + '" loading="lazy">';
      html += '<span class="ns-icon-label">' + icon.label + '</span>';
      html += '</label>';
    }
    html += '</div>';

    picker.innerHTML = html;
    bindCategoryTabs();
  }

  function bindCategoryTabs() {
    var tabs = document.querySelectorAll('.ns-icon-tab');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) { t.classList.remove('active'); });
        tab.classList.add('active');
        activeCategory = tab.getAttribute('data-category');
        filterIcons();
      });
    });
  }

  function filterIcons() {
    var options = document.querySelectorAll('.ns-icon-option');
    options.forEach(function (el) {
      var cat = el.getAttribute('data-category');
      if (activeCategory === 'all' || cat === activeCategory) {
        el.style.display = '';
      } else {
        el.style.display = 'none';
      }
    });
  }

  // --- Shape ---
  function bindShapeOptions() {
    var options = document.querySelectorAll('.ns-shape-option');
    options.forEach(function (el) {
      el.addEventListener('click', function () {
        options.forEach(function (o) { o.classList.remove('selected'); });
        el.classList.add('selected');
        state.shape = el.getAttribute('data-value');
        hideError(shapeError);
        markConfigStart('shape_select');
        updatePreview();
      });
    });
  }

  // --- Color ---
  function bindColorOptions() {
    var options = document.querySelectorAll('.ns-color-option');
    options.forEach(function (el) {
      el.addEventListener('click', function () {
        options.forEach(function (o) { o.classList.remove('selected'); });
        el.classList.add('selected');
        state.color = el.getAttribute('data-value');
        hideError(colorError);
        markConfigStart('color_select');
        updatePreview();
      });
    });
  }

  // --- Icon toggle ---
  function bindIconToggle() {
    var options = document.querySelectorAll('.ns-icon-toggle-option');
    var picker  = document.getElementById('ns-icon-picker');
    options.forEach(function (el) {
      el.addEventListener('click', function () {
        options.forEach(function (o) { o.classList.remove('selected'); });
        el.classList.add('selected');
        var val = el.getAttribute('data-value');
        state.withIcon = (val === 'yes');
        markConfigStart('icon_toggle');
        if (!state.withIcon) {
          state.icon = null;
          state.iconUrl = null;
          var iconOpts = document.querySelectorAll('.ns-icon-option');
          iconOpts.forEach(function (o) { o.classList.remove('selected'); });
        }
        picker.classList.toggle('visible', state.withIcon);
        hideError(iconToggleError);
        hideError(iconError);
        updateCharCounter();
        updatePreview();
      });
    });
  }

  // --- Icon picker ---
  function bindIconPicker() {
    var options = document.querySelectorAll('.ns-icon-option');
    options.forEach(function (el) {
      el.addEventListener('click', function () {
        options.forEach(function (o) { o.classList.remove('selected'); });
        el.classList.add('selected');
        state.icon = el.getAttribute('data-value');
        state.iconUrl = el.getAttribute('data-url');
        hideError(iconError);
        markConfigStart('icon_select');
        updatePreview();
      });
    });
  }

  // --- Name input ---
  function bindNameInput() {
    nameInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        e.stopPropagation();
      }
    });
    nameInput.addEventListener('input', function () {
      state.name = nameInput.value;
      updateCharCounter();
      hideError(nameError);
      if (state.name.trim()) {
        markConfigStart('name_input');
      }
      updatePreview();
    });
  }

  function getMaxChars() {
    return state.withIcon ? MAX_CHARS_WITH_ICON : MAX_CHARS_NO_ICON;
  }

  function updateCharCounter() {
    var max = getMaxChars();
    var len = state.name.length;
    charCounter.textContent = len + ' / ' + max;
    if (len > max) {
      charCounter.classList.add('over-limit');
      nameInput.classList.add('error');
    } else {
      charCounter.classList.remove('over-limit');
      nameInput.classList.remove('error');
    }
  }

  // --- Preview ---
  function updatePreview() {
    var svgHTML = '';
    var stampClass = '';

    if (state.shape === 'QN32') {
      stampClass = 'circle';
      svgHTML = buildCircleStampSVG();
      previewStamp.className = 'ns-preview-stamp ' + stampClass;
      previewStamp.innerHTML = svgHTML;
      previewContent.innerHTML = '';
      previewContent.style.display = 'none';
      maybeTrackPreviewReady();
      return;
    } else if (state.shape === 'QN41') {
      stampClass = 'rectangle';
      svgHTML = '<svg class="ns-stamp-bg" viewBox="0 0 280 58"><rect x="1" y="1" width="278" height="56" rx="28" fill="#ffffff" stroke="#222" stroke-width="2"/></svg>';
    } else {
      previewStamp.className = 'ns-preview-stamp';
      previewStamp.innerHTML = '';
      previewContent.style.display = '';
      previewContent.innerHTML = '<span class="ns-preview-placeholder">Select a shape to see preview</span>';
      return;
    }

    previewStamp.className = 'ns-preview-stamp ' + stampClass;
    previewStamp.innerHTML = svgHTML;
    previewContent.style.display = '';
    previewStamp.appendChild(previewContent);

    var html = '';
    if (state.withIcon && state.icon && state.iconUrl) {
      html += '<img class="ns-preview-icon-img" src="' + state.iconUrl + '" width="44" height="44" alt="' + state.icon + '">';
    }

    if (state.name) {
      var fontSize = calcFontSize(state.name.length, state.shape);
      html += '<span class="ns-preview-name" style="font-size:' + fontSize + 'px">' + escapeHTML(state.name) + '</span>';
    } else {
      html += '<span class="ns-preview-placeholder" style="font-size:13px">Type a name</span>';
    }

    previewContent.innerHTML = html;
    maybeTrackPreviewReady();
  }

  function buildCircleStampSVG() {
    var size = 220;
    var cx = size / 2;
    var cy = size / 2;
    var outerR = 106;
    var textR = 80;

    var svg = '<svg class="ns-stamp-bg" viewBox="0 0 ' + size + ' ' + size + '" xmlns="http://www.w3.org/2000/svg">';
    svg += '<circle cx="' + cx + '" cy="' + cy + '" r="' + outerR + '" fill="#ffffff" stroke="#222" stroke-width="2"/>';

    if (state.withIcon && state.icon && state.iconUrl) {
      svg += '<image href="' + state.iconUrl + '" x="' + (cx - 42) + '" y="' + (cy - 42) + '" width="84" height="84"/>';
    }

    if (state.name) {
      var escapedName = escapeHTML(state.name);
      var fontSize = calcCircleTextSize(state.name.length);
      var startAngle = -180;
      var endAngle = 0;
      var startRad = startAngle * Math.PI / 180;
      var endRad = endAngle * Math.PI / 180;
      var x1 = cx + textR * Math.cos(startRad);
      var y1 = cy + textR * Math.sin(startRad);
      var x2 = cx + textR * Math.cos(endRad);
      var y2 = cy + textR * Math.sin(endRad);

      svg += '<defs><path id="ns-text-arc" d="M ' + x1 + ' ' + y1 + ' A ' + textR + ' ' + textR + ' 0 1 1 ' + x2 + ' ' + y2 + '"/></defs>';
      svg += '<text font-size="' + fontSize + '" fill="#333" font-weight="700" letter-spacing="1" font-family="Arial, PMingLiU, 新細明體, serif">';
      svg += '<textPath href="#ns-text-arc" startOffset="50%" text-anchor="middle">' + escapedName + '</textPath>';
      svg += '</text>';
    } else if (!state.name) {
      svg += '<text x="' + cx + '" y="' + (state.withIcon && state.icon ? cy + 36 : cy + 4) + '" text-anchor="middle" font-size="13" fill="#bbb" dominant-baseline="central" font-family="Arial, PMingLiU, 新細明體, serif">Type a name</text>';
    }

    svg += '</svg>';
    return svg;
  }

  function calcCircleTextSize(len) {
    if (len <= 3) return 30;
    if (len <= 6) return 26;
    if (len <= 9) return 22;
    if (len <= 12) return 19;
    if (len <= 15) return 16;
    if (len <= 18) return 14;
    return 12;
  }

  function calcFontSize(len, shape) {
    if (shape === 'QN32') {
      if (len <= 3) return 36;
      if (len <= 6) return 32;
      if (len <= 9) return 28;
      if (len <= 12) return 24;
      if (len <= 15) return 20;
      if (len <= 18) return 17;
      return 14;
    } else {
      if (len <= 4) return 32;
      if (len <= 8) return 28;
      if (len <= 12) return 24;
      if (len <= 16) return 20;
      if (len <= 20) return 18;
      if (len <= 24) return 16;
      return 14;
    }
  }

  function escapeHTML(str) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }

  // --- Validation ---
  function validate() {
    var valid = true;

    if (!state.shape) {
      showError(shapeError, 'Please select a stamp shape');
      valid = false;
    }
    if (!state.color) {
      showError(colorError, 'Please select a color');
      valid = false;
    }
    if (state.withIcon === null) {
      showError(iconToggleError, 'Please choose with or without icon');
      valid = false;
    }
    if (state.withIcon && !state.icon) {
      showError(iconError, 'Please select an icon');
      valid = false;
    }
    if (!state.name.trim()) {
      showError(nameError, 'Please enter a name');
      nameInput.classList.add('error');
      valid = false;
    } else if (state.name.length > getMaxChars()) {
      showError(nameError, 'Name exceeds maximum ' + getMaxChars() + ' characters');
      nameInput.classList.add('error');
      valid = false;
    }

    return valid;
  }

  function showError(el, msg) {
    el.textContent = msg;
    el.classList.add('visible');
  }

  function hideError(el) {
    if (el) {
      el.classList.remove('visible');
      el.textContent = '';
    }
  }

  // --- Add to Cart ---
  function bindAddToCart() {
    addBtn.addEventListener('click', function (e) {
      e.preventDefault();
      if (!validate()) {
        trackValidationErrors();
        return;
      }

      var iconValue = (state.withIcon && state.icon) ? state.icon : 'None';

      var variantId = form.getAttribute('data-variant-id');

      var body = {
        id: variantId,
        quantity: 1,
        properties: {
          'Stamp Type': state.shape,
          'Color': state.color,
          'Name': state.name.trim(),
          'Icon': iconValue
        }
      };

      addBtn.disabled = true;
      addBtn.textContent = '加入中...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      })
      .then(function (res) {
        if (!res.ok) throw new Error('Add to cart failed');
        return res.json();
      })
      .then(function () {
        var ecommerceItem = {
          item_id: variantId,
          item_name: 'Custom Kids Name Stamp',
          item_category: 'custom_stamp',
          item_variant: [state.shape || '', state.color || '', iconValue].filter(Boolean).join(' / '),
          quantity: 1,
          price: 120
        };
        trackEvent('add_to_cart', {
          currency: 'HKD',
          value: 120,
          items: [ecommerceItem]
        });
        trackEvent('stamp_add_to_cart_success', getBaseEventParams());
        addBtn.textContent = '已加入！';
        setTimeout(function () {
          addBtn.disabled = false;
          addBtn.textContent = '加入購物車 — HKD 120';
        }, 1500);
      })
      .catch(function () {
        trackEvent('stamp_add_to_cart_error', getBaseEventParams());
        addBtn.disabled = false;
        addBtn.textContent = '加入購物車 — HKD 120';
        alert('未能加入購物車，請再試一次。');
      });
    });
  }

  // --- Init on DOM ready ---
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();


